import { Component, Input } from '@angular/core';
import { Show } from '../../../models/Show';

@Component({
  selector: 'app-show-small',
  imports: [],
  templateUrl: './show-small.component.html',
  styleUrl: './show-small.component.scss',
})
export class ShowSmallComponent {
  @Input() show!: Show;	

  //function to format date
  formatDate(date: Date): string {
    return date.toLocaleDateString('nl-BE', {
      month: 'numeric',
      day: 'numeric',
      year: 'numeric',
    });
  }
}
